/* tslint:disable */
/* eslint-disable */
/**
 * eventLog driver-registration-event-log api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { EventUserType } from './EventUserType';

export interface EventLogTrackRequest {
    /** min length: 36, max length: 36 */
    anonymous_id?: string | null;
    /** min length: 1, max length: 255 */
    user_id?: string | null;
    user_type: EventUserType;
    /** min length: 1, max length: 255 */
    page: string;
    /** min length: 1, max length: 255 */
    event: string;
    event_timestamp_ms: number;
    user_agent?: string;
    version?: string;
    app_version?: string;
    save_to_logger?: boolean;
}
